import { render, staticRenderFns } from "./ButtonSubCategory.vue?vue&type=template&id=32e765e2&scoped=true"
import script from "./ButtonSubCategory.vue?vue&type=script&lang=js"
export * from "./ButtonSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e765e2",
  null
  
)

export default component.exports